// Import Styles
import './styles/index.css';

// Import Modules
import { initNavigation } from './js/navigation.js';
import { initScrollEffects } from './js/scroll-effects.js';
import { initModal } from './js/modal.js';
import { initFAQ } from './js/faq.js';

// Initialize App
document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initScrollEffects();
  initModal();
  initFAQ();
  console.log('App cargada correctamente');
});
